import React, { useState } from "react";
import GreenPersonalProfile from "./EditedProfilesPage/GreenPersonalProfile.js";
import GreenEducationalProfile from "./EditedProfilesPage/GreenEducationalProfile";
import GreenTutorPreference from "./EditedProfilesPage/GreenTutorPreference";

const EditProfile = ({profileData}) => {
  const [active, setActive] = useState("personal");

  // Helper function to determine the active button classes
  const getButtonClasses = (type) => {
    const isActive = active === type;
    return `w-full h-16 border-r font-montserrat text-md  duration-200 ${
      isActive ? "bg-green-700 text-white" : "text-green-900"
    }`;
  };

  return (
    <div>
      <div className="flex flex-row justify-between bg-white rounded-lg">
        <button
          className={`${getButtonClasses("personal")} rounded-l-lg`}
          onClick={() => setActive("personal")}
        >
          Personal Information
        </button>
        <button
          className={getButtonClasses("educational")}
          onClick={() => setActive("educational")}
        >
          Educational Information
        </button>
        <button
          className={`${getButtonClasses("preference")} rounded-r-lg`}
          onClick={() => setActive("preference")}
        >
          Preference Information
        </button>
      </div>

      {active === "personal" && <GreenPersonalProfile profileData={profileData} title="1" />}
      {active === "educational" && <GreenEducationalProfile profileData={profileData} title="1" />}
      {active === "preference" && <GreenTutorPreference profileData={profileData} title="1" />}
    </div>
  );
};

export default EditProfile;
